import React, { Component, Fragment } from 'react';
import  {MSG_ERR, MSG_OK, MSG_WARN } from '../App';
import axios from 'axios';


const PENDING_FRIENDS = "PENDING_FRIENDS"
const FRIENDS_TRANS = "FRIENDS_TRANS"
const INVITE_FRIEND = "INVITE_FRIEND"







class friends extends Component {

    state = {
        current_page: INVITE_FRIEND,
        email: null,
        pending_friends: [],
        friend_trans: []


    }


    onSubmit = e => {
        const { displayMsg } = this.props
    
        e.preventDefault();
        

        const json_referral = {
            "referee": localStorage.getItem('colId'),
            "ref_email": this.state.email
        }

        const json_headers = {
            'Content-Type': 'application/json',
            'X-CSRFToken': localStorage.getItem('csrftoken'),
            Authorization: `Token ${localStorage.getItem('token')}`
        }


        axios
            .post('/api/referrals_pending/', json_referral, json_headers)
            .then(() => {
                displayMsg("Invitation Sent", MSG_OK)
                this.get_pending_friends()

            })
            .catch(() => {
                displayMsg("Error sending Referral. Please try again", MSG_ERR)
            })
        this.setState({ email: "" })
        

    }
    

    
    get_friends_transactions = () => {


        let prev_name = ""
        let Ts = []
        let friendsTs = []

        const { displayMsg } = this.props

        const params = {
            colId: localStorage.getItem('colId'),
        }

        const json_headers = {
            'Content-Type': 'application/json',
            'X-CSRFToken': localStorage.getItem('csrftoken'),
            Authorization: `Token ${localStorage.getItem('token')}`
        }

        axios.get('/api/referrals_transactions/', { params, headers: json_headers })
            .then(res => {
                res.data.map(d => {
                    if (d.col_name !== prev_name) {
                        friendsTs.push({
                            'col_name': d.col_name,
                            'Ts': []
                        });
                    }
                    friendsTs.at(-1).Ts.push({
                        'trans_datetime': d.trans_datetime,
                        'trans_support': d.trans_support,
                        'trans_amount': d.trans_amount
                    });
                    prev_name = d.col_name;
                })
            })
            .catch(() => {
                displayMsg("Error retrieving data. Please try again", MSG_ERR)
            })
        
        this.setState({ friend_trans: friendsTs })       
    }

    FriendsTransactions = () => {

        let prev_name = ""

        if (this.state.friend_trans.length == 0)
            return <p>No friends with transaccions registered</p>
        else
            return (
                <Fragment>
                    {this.state.friend_trans.map(friend => (
                        <div className='container-fluid border-top m-2'>
                            <div className="position-relative m-1" key={friend.pk}>
                                <font size="3">{friend.col_name}</font><br />
                            </div>
                            {friend.Ts.map(t => (
                                <div> <font size="1">
                                    {t.trans_datetime + ">" + t.trans_amount + "  " + t.trans_support}
                                </font></div>
                                ))
                            }
                        </div>))
                        }
                </Fragment>
            )
        
    }
     

    get_pending_friends = () => {
    

        const { displayMsg } = this.props

        const params = {
            colId: localStorage.getItem('colId'),
        }

        const json_headers = {
            'Content-Type': 'application/json',
            'X-CSRFToken': localStorage.getItem('csrftoken'),
            Authorization: `Token ${localStorage.getItem('token')}`
        }

        axios.get('/api/referrals_pending/', { params, headers: json_headers })
            .then(res => {
                this.setState({ pending_friends: res.data })
            })
            .catch(() => {
                displayMsg("Error sending Referral. Please try again", MSG_ERR)
            })
    }

    
    reSendInvite(email) {

        const { displayMsg } = this.props


        const json_referral = {
            "referee": localStorage.getItem('colId'),
            "ref_email": email
        }

        const json_headers = {
            'Content-Type': 'application/json',
            'X-CSRFToken': localStorage.getItem('csrftoken'),
            Authorization: `Token ${localStorage.getItem('token')}`
        }


        axios
            .post('/api/referrals_pending/', json_referral, json_headers)
            .then(() => {
                displayMsg("Invitation Sent", MSG_OK)
            })
            .catch(() => {
                displayMsg("Error sending Referral. Please try again", MSG_ERR)
            })
       

    }
    

    PendingReferrals = () => {
        if (this.state.pending_friends.length == 0)
            return <p>No friends with registration pending</p>
        else
            return (
                <Fragment>
                { this.state.pending_friends.map(ref => (
                        <div className='container-fluid border-top m-2'>
                            <div className="position-relative m-1" key={ref.pk}>
                                <font size="2">{ref.ref_email}</font><br />
                            </div>
                            <div className="position end-0">
                                <button onClick={() => this.reSendInvite(ref.ref_email)}
                                    className="btn btn-primary btn-sm m-2">
                                    Reenviar email </button>
                                
                            </div>
                        </div>))}
                </Fragment>
            )
    
    }
    
    InviteFriend =() => {
        

        return (
            <div className="card card-body mt-4 mb-4">
                <form onSubmit={this.onSubmit}>
                    <label htmlFor='email'>Email address:</label> <br />
                    <input
                        name='email'
                        type='email'
                        value={this.state.email}
                        required
                        onChange={(e) => this.setState({ email: e.target.value } )}
                    />{' '}
                    <br />
                    <button type="submit" 
                                        className="btn btn-primary m-2">
                                        Submit
                        </button>
                    </form>
            </div>

        )
    }
     


    toogleClick = (page) => {
        this.setState({current_page: page})
    
    }

    render_body = () => {
        switch (this.state.current_page) {
            
            case PENDING_FRIENDS:
                return this.PendingReferrals()
                
            case FRIENDS_TRANS:
                return this.FriendsTransactions()
                
            default:
                return this.InviteFriend()
        }           
    }


    componentDidMount() {
        this.get_pending_friends();
        this.get_friends_transactions();
    };

    render() {
        
        const invite_classname = "btn btn-sm btn-outline-secondary" + (this.state.current_page == INVITE_FRIEND? " active" : "")
        const pending_classname = "btn btn-sm btn-outline-secondary" + (this.state.current_page == PENDING_FRIENDS? " active":"")
        const trans_classname = "btn btn-sm btn-outline-secondary" + (this.state.current_page == FRIENDS_TRANS? " active":"")

        return (
            <Fragment>
            <nav className="navbar-light bg-light py-2 position-relative" > 
                    <a className="navbar-brand">Amigos</a>
                    <div className="btn-group position-absolute end-0  mr-2" role="group" data-toggle="buttons">
                            <button type="button" className={invite_classname}
                                onClick={() => this.toogleClick(INVITE_FRIEND)}>Invite</button>
                            <button type="button" className={pending_classname}
                                onClick={() => this.toogleClick(PENDING_FRIENDS)}>Pending</button>
                            <button type="button" className={trans_classname}
                                onClick={() => this.toogleClick(FRIENDS_TRANS)}>Trans.</button>
                        </div>
            </nav>
            <ul className="list-group list-group-flush">
                    {this.render_body()}
            
            </ul>
        </Fragment>

        )


    }
}
 
export  default friends ;